import { render } from "./FileList.vue?vue&type=template&id=6fc47254&ts=true"
import script from "./FileList.vue?vue&type=script&lang=ts"
export * from "./FileList.vue?vue&type=script&lang=ts"

import "./FileList.vue?vue&type=style&index=0&id=6fc47254&lang=scss"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__